export default {
  integrationTimestamp(state) {
    return state.integrationTimestamp;
  },
  integrations(state) {
    return state.integrations;
  },
  features(state) {
    return state.features;
  },
  carriers(state) {
    return state.carriers;
  },
};
